import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { startRegistration } from '@simplewebauthn/browser';
import type { PublicKeyCredentialCreationOptionsJSON } from '@simplewebauthn/browser';
import { KeyRound } from 'lucide-react';
import { post } from '../../lib/api';
import { Button } from '../../components/ui/button';
import { ErrorNotice, Notice } from '../../components/ui/common';

export function PasskeySetup({ token }: { token?: string }) {
  const [complete, setComplete] = useState(false);
  const setup = useMutation({ mutationFn: async () => {
    const { options } = await post<{ options: PublicKeyCredentialCreationOptionsJSON }>('/auth/passkeys/register/options', { token });
    const response = await startRegistration({ optionsJSON: options });
    await post('/auth/passkeys/register/verify', { token, response });
  }, onSuccess: () => setComplete(true) });
  return <div className="passkey-setup">{complete ? <Notice tone="success">Your passkey has been registered. You can use it to sign in on this domain.</Notice> : <><p>Use your device’s fingerprint, face recognition or security key to sign in securely.</p><Button variant="outline" disabled={setup.isPending} onClick={() => setup.mutate()}><KeyRound size={17} />{setup.isPending ? 'Waiting for your device…' : 'Register a passkey'}</Button></>}{setup.error && <ErrorNotice error={setup.error} />}</div>;
}
